<template>
    <div class="sag-form">
        <slot></slot>
    </div>    
</template>
<script>
import { BRow, BCol, BButton } from 'bootstrap-vue'
import SagRightSideBarBase from '@/components/sag-right-side-bar/SagRightSideBarBase.vue'

export default {
    components: {
        SagRightSideBarBase,
        BButton,
        BRow,
        BCol
    },
    props: {
        url: {
            type: String
        }
    },
    setup(props) {
        
    }
}
</script>
